import React from 'react';
import { Outlet } from 'react-router-dom';
import PartnerDetail from './PartnerDetail';

const PartnerDetailLayout = () => {
  return (
    <>
      {/* PartnerDetail reste toujours monté */}
      <PartnerDetail />

      {/* Outlet pour les routes enfants (IndividualDetailPage) qui s'affichent par-dessus */}
      <Outlet />
    </>
  );
};

export default PartnerDetailLayout;
